import { FunctionComponent } from 'react'
import { DocumentSummaryCounts } from '@black-bear-energy/black-bear-energy-common'
import { colors, rucksack, Tooltip } from '@black-bear-energy/rucksack'
import {
  CheckCircleRounded,
  ErrorOutlineRounded,
  RemoveCircleOutlineRounded,
} from '@mui/icons-material'

export const ReviewsIcon: FunctionComponent<ReviewsIconProps> = ({
  verified,
  pendingReview,
}: ReviewsIconProps) => {
  if (verified.denominator == 0) {
    // no documents uploaded yet
    return (
      <Tooltip title="No Documents Pending Review">
        <RemoveCircleOutlineRounded sx={{ color: colors.ore[500] }} />
      </Tooltip>
    )
  }

  if (pendingReview > 0) {
    return (
      <Tooltip title="Reviews Needed">
        <ErrorOutlineRounded sx={{ color: rucksack.palette.warning.main }} />
      </Tooltip>
    )
  }

  return (
    <Tooltip title="All Documents Reviewed">
      <CheckCircleRounded sx={{ color: rucksack.palette.success.main }} />
    </Tooltip>
  )
}

export interface ReviewsIconProps {
  verified: DocumentSummaryCounts['verified']
  pendingReview: number
}
